import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center w-full h-full" }
const _hoisted_2 = { class: "w-11/12 pt-16 bg-white sm:w-96 max-w-96" }
const _hoisted_3 = { class: "my-5" }
const _hoisted_4 = ["onSubmit"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-bold" }, "Forgotten your password?", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", null, " If we find your account with the email you provide, we will send you a link to reset your password. ", -1)

import Button from '@/components/UI/Button.vue';
import { useRouter } from 'vue-router';
import { useUserStore } from '@/store/users';
import { onErrorCaptured, ref, toRefs } from 'vue';
import FloatingHeaderTextField from '@/components/Inputs/FloatingHeaderTextField.vue';
import Logo from '@/components/UI/Logo.vue';


export default /*#__PURE__*/_defineComponent({
  props: {
  email: {
    type: String,
    default: '',
  },
},
  setup(__props) {

const props = __props

const router = useRouter();



const { email } = toRefs(props);

const forgottenEmail = ref(email.value);
const error = ref('');

const userStore = useUserStore();

async function reset() {
  if (forgottenEmail.value.trim().length) {
    await userStore.resetPassword(forgottenEmail.value);
    router.push('login');
  } else {
    error.value = 'Email must not be blank';
  }
}

onErrorCaptured((err) => {
  console.error(err);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Logo),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", {
          class: "px-4 space-y-6 text-center",
          onSubmit: _withModifiers(reset, ["prevent"])
        }, [
          _hoisted_5,
          _hoisted_6,
          _createVNode(FloatingHeaderTextField, {
            title: "Email",
            modelValue: forgottenEmail.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((forgottenEmail).value = $event)),
            "validation-error": error.value
          }, null, 8, ["modelValue", "validation-error"]),
          _createVNode(Button, {
            label: "Reset your password",
            type: "primary",
            class: "w-full py-3 font-bold rounded text-md"
          }),
          _createVNode(Button, {
            label: "Back",
            type: "secondary",
            class: "w-full py-3 font-bold rounded text-md",
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$router.back()), ["prevent"]))
          })
        ], 40, _hoisted_4)
      ])
    ])
  ]))
}
}

})